import { createRenderBatcher as e } from "./atoms-v2986.js";
const { schedule: r, cancel: a } = e(queueMicrotask, !1);
export {
  a as cancelMicrotask,
  r as microtask
};
